<template>
  <v-btn-form :title="title" @close="cancel()" listable>
        <template v-for="item in this.filteredItems">
          <v-flex mb-1>
          <v-card v-bind:key="getItemKey(item)" @click.stop="click(item)">
            <v-card-text>
              <v-flex xs12 sm12>
                <b>{{item.title}}</b>
              </v-flex>
              <v-layout row wrap>
              <v-flex xs12 sm6>
                <v-chips-field 
                  emptyChip="Паспортные данные"
                  solo flat
                  @remove="removePassport(item)" 
                  @click="clickPassport(item)" 
                  :items="item.passportId ? [{value: item.passportId + '', text: item.text, hint: item.text, error: null}] : []"
                  :chipSize="getIsMobile ? 25 : 25" > 
                </v-chips-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-chips-field
                  emptyChip="Контактная информация"
                  solo flat
                  @remove="removeContact(item)" 
                  @click="clickContact(item)" 
                  :items="item.contactId ? [{value: item.contactId + '', text: getContact(item), hint: getContactHint(item), error: null}] : []"
                  :chipSize="getIsMobile ? 25 : 25" > 
                </v-chips-field>
              </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        </template>
    <template #actions>
      <v-btn @click="ok">ОК</v-btn>
    </template>
  </v-btn-form>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import classes from '../../api/classes'
  import formats from '../../api/formats'
  import forms from '../common/forms.js'
  import client from '../client/index.js'
  import people from './index.js'
  import vBtnForm from '../common/BtnForm'
  import vChipsField from '../common/ChipsField.vue'
  // import depo from '.'

  export default {
    name: 'holder-list',
    components: {vBtnForm, vChipsField},
    data: () => ({
      cxt: null,
      items: []
    }),
    props: {
      fullscreen: {
        type: Boolean,
        default: false
      },
      radio: {
        type: Boolean,
        default: false
      },
      selected: {
        type: Array,
        default: function () {
          return []
        }
      },
      holders: {
        type: Array,
        default: function () {
          return []
        }
      },
      title: {
        type: String,
        default: 'Выберите документ'
      },
      companyRefCode: {
        type: String,
        default: null
      }
    },
    created () {
      var cxt = new classes.MultiSelectContext(() => {
        return this.filteredItems.map(item => this.getItemKey(item))
      })
      // cxt.mode = classes.modes.SELECT
      this.cxt = cxt
      if (this.selected != null) {
        this.selected.forEach(id => this.cxt.select(id))
      }
    },
    mounted () {
      this.fetchData()
    },
    watch: {
      companyRefCode: function (newVal, oldVal) { // watch it
        this.fetchData()
      },
      holders: function (newVal, oldVal) { // watch it
        this.fetchData()
      }
    },
    computed: {
      ...mapGetters({
        getIsMobile: 'getIsMobile',
        calcDialogScroll: 'calcDialogScroll'
      }),
      orderedItems () {
        // console.log('orderedItems', this.items)
        return this.items.sort((a, b) => formats.compareString(a.title, b.title))
      },
      filteredItems () {
        const getSearchString = (item) => {
          return ''
            .concat(item.title)
            .concat(item.text)
        }
        var filter = (!this.cxt.isFilterMode()) || (this.cxt.filterString === null) || (this.cxt.filterString.length < 3) ? null : this.cxt.filterString.toUpperCase()
        if (!filter) {
          return this.orderedItems
        }
        return this.orderedItems.filter(item => {
          return getSearchString(item).toUpperCase().includes(filter)
        })
      }
    },
    methods: {
      getItemKey (item) {
        return item.value
      },
      fetchData () {
        if (this.holders) {
          console.log('fetchData', this.holders)
          this.holders.forEach(h => {
            let item = {value: h.ref, title: h.name, text: null, ref: h.ref, name: h.name, share: h.share, personId: h.personId, individual: h.individual, passportId: h.passportId, passport_rf: h.passport_rf, contactId: h.contactId, contact: h.contact, innfl: h.innfl}
            item.text = this.getText(item)
            this.items.push(item)
          })
        }
      },
      ok () {
        let holders = []
        this.items.forEach(i => {
          holders.push({
            ref: i.ref,
            name: i.name,
            share: i.share,
            innfl: i.innfl,
            personId: i.personId,
            individual: i.individual,
            passportId: i.passportId,
            passport_rf: i.passport_rf,
            contactId: i.contactId,
            contact: i.contact,
            reason: ''
          })
        })
        console.log('input', holders)
        this.$emit('input', holders)
        this.cancel()
      },
      cancel () {
        this.$emit('close')
        this.itemId = null
      },
      select (uid) {
        if (this.cxt.uncheck(uid)) {
          if (this.radio) {
            this.cxt.clear()
          }
        }
        this.cxt.select(uid)
      },
      click (item) {
      },
      removePassport (item) {
        item.passportId = null
        item.passport_rf = null
      },
      clickPassport (item) {
        if (this.cxt === classes.modes.SELECT) {
          this.select(this.getItemKey(item))
        } else {
          this.onClickPassport(item)
        }
      },
      removeContact (item) {
        item.contactId = null
        item.contact = null
      },
      clickContact (item) {
        if (this.cxt === classes.modes.SELECT) {
          this.select(this.getItemKey(item))
        } else {
          this.onClickContact(item)
        }
      },
      onChangeFilter (e) {
        this.cxt.filterString = e
      },
      onSetItem (values) {
        if (Array.isArray(values) && values.length > 0) {
          // this.setCode(model, values[0], onChange)
        }
      },
      getText (item) {
        console.log('getText', item)
        let fstrategy = people.createStrategy(this, 'PASSPORT_RF')
        return item.passport_rf ? `Паспорт: ${item.passport_rf.surname} ${item.passport_rf.firstname} ${item.passport_rf.patronymic} ${fstrategy.viewNumber(item.passport_rf)}` : 'Введите паспортные данные'
      },
      getContact (item) {
        let fstrategy = people.createStrategy(this, 'CONTACT')
        return item.contact ? ` ${fstrategy.viewNumber(item.contact)}` : 'Введите контактные данные'
      },
      getContactHint (item) {
        let fstrategy = people.createStrategy(this, 'CONTACT')
        return item.contact ? ` ${fstrategy.viewContent(item.contact)}` : ''
      },
      openPassport (item) {
        const type = 'PASSPORT_RF'
        const getQuery = () => ''
        const setPassport = (fstrategy, passportId) => {
          item.passportId = passportId
          fstrategy.fetchData(item.passportId).then(data => {
            let model = fstrategy.createModelFromData(data)
            item.passport_rf = model
            item.text = this.getText(item)
          })
        }
        let personId = item.personId
        let passportId = item.passportId
        let fstrategy = people.createStrategy(this, type)
        if (!fstrategy) {
          return
        }
        people.getIndividual(personId).then((individual) => {
          if (passportId) {
            fstrategy.setParentProps(individual)
            forms.openFormStg(fstrategy, passportId).then(data => {
              setPassport(fstrategy, data)
            })
          } else {
            let arr = individual.docs.filter(d => d.type === type)
            if (arr.length > 0) {
              people.selectDocByIndividual(null, individual, getQuery, type).then((data) => {
                if (Array.isArray(data) && data.length > 0) {
                  setPassport(fstrategy, data[0])
                }
              })
            } else {
              fstrategy.setParentProps(individual)
              forms.openFormStg(fstrategy, null).then(data => {
                setPassport(fstrategy, data)
              })
            }
          }
        })
      },
      openContact (item) {
        const type = 'CONTACT'
        const getQuery = () => ''
        const setContact = (fstrategy, contactId) => {
          item.contactId = contactId
          fstrategy.fetchData(item.contactId).then(data => {
            let model = fstrategy.createModelFromData(data)
            item.contact = model
          })
        }
        let personId = item.personId
        let contactId = item.contactId
        let fstrategy = people.createStrategy(this, type)
        if (!fstrategy) {
          return
        }
        people.getIndividual(personId).then((individual) => {
          if (contactId) {
            fstrategy.setParentProps(individual)
            forms.openFormStg(fstrategy, contactId).then(data => {
              setContact(fstrategy, data)
            })
          } else {
            let arr = individual.contacts
            if (arr.length > 0) {
              people.selectContactByIndividual(null, individual, getQuery).then((data) => {
                if (Array.isArray(data) && data.length > 0) {
                  setContact(fstrategy, data[0])
                }
              })
            } else {
              fstrategy.setParentProps(individual)
              forms.openFormStg(fstrategy, null).then(data => {
                setContact(fstrategy, data)
              })
            }
          }
        })
      },
      onClickPassport (item) {
        const setPerson = (innfl) => {
          people.findIndividualByInn(item.innfl).then((person) => {
            if (person) {
              item.personId = person.id
              item.individual = person
              this.openPassport(item)
            } else {
              client.getHumanProps(item.innfl).then((human) => {
                people.addHuman(this.companyRefCode, human).then((id) => {
                  item.personId = id
                  item.individual = person
                  this.openPassport(item)
                })
              })
            }
          })
        }
        const setIndividual = (values) => {
          if (Array.isArray(values) && values.length > 0) {
            let id = values[0]
            people.getIndividual(id)
            .then(person => {
              if (person) {
                item.innfl = person.inn
                item.personId = person.id
                item.individual = person
                this.openPassport(item)
              }
            })
          }
        }
        const getQuery = () => {
          return null
        }
        if (!item.innfl) {
          people.selectIndividual(this, this.companyRefCode, getQuery, true, true)
          .then(data => setIndividual(data))
        } else {
          setPerson(item.innfl)
        }
      },
      onClickContact (item) {
        const setPerson = (innfl) => {
          people.findIndividualByInn(item.innfl).then((person) => {
            if (person) {
              item.personId = person.id
              item.individual = person
              this.openContact(item)
            } else {
              client.getHumanProps(item.innfl).then((human) => {
                people.addHuman(this.companyRefCode, human).then((id) => {
                  item.personId = id
                  item.individual = person
                  this.openContact(item)
                })
              })
            }
          })
        }
        const setIndividual = (values) => {
          if (Array.isArray(values) && values.length > 0) {
            let id = values[0]
            people.getIndividual(id)
            .then(person => {
              if (person) {
                item.innfl = person.inn
                item.personId = person.id
                item.individual = person
                this.openContact(item)
              }
            })
          }
        }
        const getQuery = () => {
          return null
        }
        if (!item.innfl) {
          client.selectIndividual(this, this.companyRefCode, getQuery, true, true)
          .then(data => setIndividual(data))
        } else {
          setPerson(item.innfl)
        }
      }
    }
  }
</script>




// WEBPACK FOOTER //
// HolderList.vue?044043f6